import React, { useEffect, useMemo, useState } from "react";
import ComponentCustomModal from "../../components/common/customModal/ComponentCustomModal";
import CanvasJSReact from "@canvasjs/react-charts";
import { getCustomerBandwidthUsageChart } from "../../features/apiCalls";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Loader from "../../components/common/Loader";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const BandwidthUsage = ({ show, setShow, customer }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  //--->  @Get dashboard middle monthly collection graph chart data
  const chartsData = useSelector((state) => state.chart.bandwidthUsageCharts);

  //---> Local states
  const [isLoading, setIsloading] = useState(false);
  const [dps1, setDps1] = useState([]);
  const [dps2, setDps2] = useState([]);
  const [xVal, setXVal] = useState(0);
  const [filter, setFilter] = useState("month");

  const dataLength = 150;

  const formatToMbps = (value) => {
    return (value / 1024 / 1024).toFixed(2);
  };

  useEffect(() => {
    if (filter) {
      getCustomerBandwidthUsageChart(
        dispatch,
        customer?.id,
        filter,
        setIsloading,
      );
    }
  }, [show, filter]);

  useEffect(() => {
    if (chartsData?.chart?.length > 0) {
      const newDps1 = chartsData.chart?.map((chunk, index) => ({
        x: index,
        y: Number(formatToMbps(chunk.rxByte)),
        tooltipUploadValue:
          formatToMbps(chunk?.rxByte) / 1024 >= 1
            ? `${(formatToMbps(chunk.rxByte) / 1024).toFixed(2)} GB`
            : `${formatToMbps(chunk.rxByte)} MB`,
        date: chunk?.upTime
          ? moment(chunk?.upTime).format("YY-MM-DD hh:mm A")
          : chunk?.day,
      }));

      const newDps2 = chartsData.chart?.map((chunk, index) => ({
        x: index,
        y: Number(formatToMbps(chunk.txByte)),
        tooltipDownloadValue:
          formatToMbps(chunk?.txByte) / 1024 >= 1
            ? `${(formatToMbps(chunk.txByte) / 1024).toFixed(2)} GB`
            : `${formatToMbps(chunk.txByte)} MB`,
        date: chunk?.upTime
          ? moment(chunk?.upTime).format("YY-MM-DD hh:mm A")
          : chunk?.day,
      }));

      setDps1(newDps1.slice(-dataLength));
      setDps2(newDps2.slice(-dataLength));

      setXVal(newDps1.length);
    } else {
      setDps1([]);
      setDps2([]);
      setXVal(0);
    }
  }, [chartsData]);

  const options = useMemo(
    () => ({
      exportEnabled: true,
      animationEnabled: true,
      axisY: {
        title: "Data Consumed (GB)",
      },
      data: [
        {
          type: "column",
          showInLegend: true,
          legendText: `Upload: ${
            formatToMbps(chartsData?.upload) / 1024 >= 1
              ? (formatToMbps(chartsData?.upload) / 1024).toFixed(2)
              : formatToMbps(chartsData?.upload)
          } ${
            Number(formatToMbps(chartsData?.upload) / 1024) >= 1 ? "GB" : "MB"
          }`,
          dataPointWidth: 2,
          dataPoints: dps1,
          toolTipContent:
            "<div>" +
            "<p>{date}</p>" +
            "<p>Upload: {tooltipUploadValue}</p>" +
            "</div>",
        },
        {
          type: "column",
          showInLegend: true,
          legendText: `Download: ${
            formatToMbps(chartsData?.download) / 1024 >= 1
              ? (formatToMbps(chartsData?.download) / 1024).toFixed(2)
              : formatToMbps(chartsData?.download)
          } ${
            Number(formatToMbps(chartsData?.download) / 1024) >= 1 ? "GB" : "MB"
          }`,
          dataPointWidth: 2,
          dataPoints: dps2,
          toolTipContent:
            "<div>" +
            "<p>{date}</p>" +
            "<p>Download: {tooltipDownloadValue}</p>" +
            "</div>",
        },
      ],
    }),
    [xVal, dps1, dps2],
  );

  return (
    <>
      <ComponentCustomModal
        show={show}
        setShow={setShow}
        centered
        size="xl"
        header={customer?.name + " " + t("dataUsageReport")}
      >
        <div>
          {/* <div className="d-flex justify-content-center align-items-center p-1">
            <div className="btn-group" role="group">
              <button
                className={`btn btn-outline-primary ${
                  filter === "day" ? "active" : ""
                }`}
                onClick={() => setFilter("day")}
              >
                {filter === "day" && isLoading ? <Loader /> : "Day"}
              </button>

              <button
                className={`btn btn-outline-primary ${
                  filter === "month" ? "active" : ""
                }`}
                onClick={() => setFilter("month")}
              >
                {filter === "month" && isLoading ? <Loader /> : "Month"}
              </button>
            </div>
          </div> */}

          <CanvasJSChart options={options} />
        </div>
      </ComponentCustomModal>
    </>
  );
};

export default BandwidthUsage;
